import React, { useContext } from "react";
import { Button } from "components/ui/button";
import { IntlContext } from "context";

type RegisterLinkProps = {
    onOpenProfileChoice: () => void;
};

const RegisterLink: React.FC<RegisterLinkProps> = ({ onOpenProfileChoice }) => {
    const intl = useContext(IntlContext);

    return (
        <p className="font-nunito text-sm font-medium leading-5 text-slate-600">
            {intl.formatMessage("authentication.register.not_yet_account")}{" "}
            <Button
                type="button"
                variant="link"
                size="none"
                onClick={onOpenProfileChoice}
                className="font-nunito text-base font-bold leading-6 text-indigo-600"
            >
                {intl.formatMessage("authentication.register.create_account")}
            </Button>
        </p>
    );
};

export default RegisterLink;
